import React from "react"
import { createIcon } from "@chakra-ui/react"

export default createIcon({
  displayName: "TbtcIcon",
  viewBox: "0 0 32 32",
  path: [
    <path
      d="M15.9667 31.9333C24.7848 31.9333 31.9333 24.7848 31.9333 15.9667C31.9333 7.14852 24.7848 0 15.9667 0C7.14852 0 0 7.14852 0 15.9667C0 24.7848 7.14852 31.9333 15.9667 31.9333Z"
      fill="black"
    />,
    <path d="M13.2361 14.4695H10.5625V17.1431H13.2361V14.4695Z" fill="white" />,
    <path
      d="M10.5624 11.7959H7.88886V14.4694L10.5625 14.4695L10.5624 11.7959Z"
      fill="white"
    />,
    <path d="M7.88842 14.4695H5.21484V17.1431H7.88842V14.4695Z" fill="white" />,
    <path
      d="M10.5625 17.1431L7.88886 17.1429V19.8165H10.5624L10.5625 17.1431Z"
      fill="white"
    />,
    <path
      d="M25.7604 12.3717C25.5719 10.4054 23.8749 9.74539 21.7314 9.55689V8.29737H20.0717V9.48503C19.6356 9.48503 19.1897 9.49339 18.7462 9.50176V8.29639H17.0875V9.55541C16.7282 9.5623 14.5208 9.56033 14.5208 9.56033L14.5158 11.0236L15.9009 11.0315V20.6218H14.5163L14.504 22.0644C14.9061 22.0644 16.6958 22.0723 17.0836 22.0748V23.318H18.7423V22.1043C19.1971 22.1141 19.6381 22.1181 20.0682 22.1176V23.3185H21.7284V22.0807C24.5196 21.9217 26.4741 21.2193 26.7168 18.5989C26.9136 16.4884 25.9214 15.5473 24.337 15.1644C25.2997 14.6722 25.9017 13.8104 25.7614 12.3712L25.7604 12.3717ZM23.4348 18.2696C23.4348 20.3314 19.9053 20.0957 18.7792 20.0962V16.4412C19.9048 16.4412 23.4329 16.1198 23.4334 18.2696H23.4348ZM22.6646 13.1125C22.6646 14.9882 19.7193 14.7682 18.7817 14.7682V11.4528C19.7208 11.4533 22.6655 11.156 22.6646 13.1125Z"
      fill="white"
    />,
  ],
})
